import { getDocumentElement, getDocumentElements } from "../../Utils/Utils";

/**
 * Create the finish section.
 * 
 * @param       {object}    options 
 * 
 * @returns     {object}
 */
const CreateFinish = options => {
    const SummarySection = getDocumentElement(options.selectors.section);
    const TopNavButtons = getDocumentElements(options.selectors.topNavButton);
    const BottomNavButtons = getDocumentElements(options.selectors.bottomNavButton);

    /**
     * Is this a number?
     * 
     * @param   {integer|string}    value 
     * 
     * @returns {boolean}
     */
    function isNumber(value) {
        return typeof value === 'number';
    };

    /**
     * Update finish fields.
     * 
     * @returns     {void}
    */
   const __updateFinish = () => {
        // Get finish fields
        const FinishFarmWaterTotalStorage = getDocumentElement('#farm-water-total-storage');
        const FinishFarmWaterTotalUse = getDocumentElement('#farm-water-total-use');
        const FinishTotalBalance = getDocumentElement('#farm-water-total-balance');
        let calc = 0;

        // Get the values
        const FarmWaterTotalStorage = getDocumentElement('.farm-calc-section--storage #waterStorageTotal').valueAsNumber;
        const FarmWaterTotalUse = getDocumentElement('.farm-calc-section--use #onFarmTotal').valueAsNumber;

        // Populate the finish fields
        FinishFarmWaterTotalStorage.innerText = isNumber(FarmWaterTotalStorage) ? FarmWaterTotalStorage : 'No value set';
        FinishFarmWaterTotalUse.innerText = isNumber(FarmWaterTotalUse) ? FarmWaterTotalUse :  'No value set';

        if (isNumber(FarmWaterTotalStorage) && isNumber(FarmWaterTotalUse)) {
            calc = parseFloat(FarmWaterTotalStorage) - parseFloat(FarmWaterTotalUse);
        } else if (isNumber(FarmWaterTotalStorage)) {
            calc = FarmWaterTotalStorage;
        } else if (isNumber(FarmWaterTotalUse)) {
            calc  = FarmWaterTotalUse * -1;
        }

        // Update the finished balance
        if (isNaN(calc)) {
            FinishTotalBalance.innerText = 'No value set';
        } else {
            FinishTotalBalance.innerText = calc.toFixed(3);
        }
    };
    
    /**
     * Bind the event listeners to force an update on the summary fields.
     * 
     * @returns     {void}
     */
    const __bind = () => {
        const WatchElements = [...BottomNavButtons, ...TopNavButtons];

        WatchElements.forEach(el => {
            el.addEventListener('click', () => {
                __updateFinish();
            });
        });
    };
    
    /**
     * Init the finish fields.
     */
    const init = () => {
        if (SummarySection && TopNavButtons && BottomNavButtons) {
            __bind();
        }
    };

    // Publicly expose the init function
    return Object.freeze({ init });
};

export default CreateFinish;